<ng-container class="op-bank-icon">
	<mat-icon [svgIcon]="bankIcon" class="icon"></mat-icon>
</ng-container>
